import React from 'react';
import { Tooltip, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import { Edit, Delete, Send, ContentCopy, Visibility, MoreVert } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface InvoiceActionsProps {
  invoice: any;
  onEdit: () => void;
  onDelete: () => void;
  onDuplicate: () => void;
}

export function InvoiceActions({ invoice, onEdit, onDelete, onDuplicate }: InvoiceActionsProps) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handlePreview = () => {
    navigate(`/invoices/${invoice.id}`);
  };

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // Remove status-based restrictions - allow all actions for all invoice statuses
  const canSend = true;
  const canDelete = true;

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls={open ? 'invoice-actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        size="small"
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '12px',
          color: 'text.secondary',
          '&:hover': {
            backgroundColor: 'rgba(74,39,79,0.06)',
            borderColor: 'rgba(74,39,79,0.2)',
            color: '#4a274f',
          },
        }}
      >
        <MoreVert />
      </IconButton>
      <Menu
        id="invoice-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => { handleClose(); onEdit(); }}>
          <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
          <ListItemText primary="Edit" />
        </MenuItem>
        <MenuItem onClick={() => { handleClose(); handlePreview(); }}>
          <ListItemIcon><Visibility fontSize="small" /></ListItemIcon>
          <ListItemText primary="Preview" />
        </MenuItem>
        {canSend && (
          <Tooltip title="Disabled during beta testing!" placement="left">
            <span>
              <MenuItem disabled>
                <ListItemIcon><Send fontSize="small" /></ListItemIcon>
                <ListItemText primary="Send" />
              </MenuItem>
            </span>
          </Tooltip>
        )}
        <MenuItem onClick={() => { handleClose(); onDuplicate(); }}>
          <ListItemIcon><ContentCopy fontSize="small" /></ListItemIcon>
          <ListItemText primary="Duplicate" />
        </MenuItem>
        {canDelete && (
          <>
            <Divider />
            <MenuItem onClick={() => { handleClose(); onDelete(); }} sx={{ color: 'error.main' }}>
              <ListItemIcon><Delete fontSize="small" color="error" /></ListItemIcon>
              <ListItemText primary="Delete" />
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
} 